<div
	class="jepto-page-editor"
	[class.jepto-page-editor--view-only]="viewOnly()"
	[attr.data-testid]="testId() ?? undefined"
>
	<div class="jepto-page-editor__body">
		<div class="jepto-page-editor__main">
			<ng-template #tabsBarTpl>
				@if (showEditChromeTabsSkeleton()) {
					<div
						class="jepto-page-editor__tabs-bar jepto-page-editor__tabs-bar--loading"
						[class.jepto-page-editor__tabs-bar--in-toolbar]="
							tabsBarInToolbar()
						"
						aria-hidden="true"
						[attr.data-testid]="
							testId() ? testId() + '-tabs-skeleton' : null
						"
					>
						<div class="jepto-page-editor__tabs-skeleton">
							@for (width of tabsSkeletonWidths; track $index) {
								<span
									class="jepto-page-editor__tabs-skeleton-tab"
									[style.width.px]="width"
								></span>
							}
						</div>
						<div class="jepto-page-editor__action-buttons">
							<span
								class="jepto-page-editor__tabs-skeleton-action"
							></span>
							<span
								class="jepto-page-editor__tabs-skeleton-action"
							></span>
						</div>
					</div>
				} @else {
					<div
						class="jepto-page-editor__tabs-bar"
						[class.jepto-page-editor__tabs-bar--in-toolbar]="
							tabsBarInToolbar()
						"
					>
						<jepto-page-editor-tabs
							[tabs]="displayedPages()"
							[selectedIndex]="displayedSelectedIndex()"
							[viewOnly]="viewOnly()"
							[initialDropdownOpen]="initialDropdownOpen()"
							[ariaLabel]="ariaLabel()"
							(tabChange)="onTabChange($event)"
						/>
						@if (!viewOnly()) {
							<div class="jepto-page-editor__action-buttons">
								<button
									type="button"
									class="jepto-page-editor__action-btn jepto-page-editor__action-btn--icon-only"
									aria-label="Manage pages"
									matTooltip="Manage pages"
									[attr.data-testid]="
										testId()
											? testId() + '-manage-btn'
											: null
									"
									(click)="openManagePanel()"
								>
									<svg
										class="jepto-page-editor__action-icon"
										width="16"
										height="16"
										viewBox="0 0 16 16"
										fill="none"
										xmlns="http://www.w3.org/2000/svg"
										aria-hidden="true"
									>
										<path
											d="M10.5117 1.81055L1.51172 10.8105V13.5H4.20117L13.2012 4.5L10.5117 1.81055ZM11.0391 0.228516L14.7832 3.97266C14.9355 4.125 15.0117 4.30664 15.0117 4.51758C15.0117 4.7168 14.9355 4.89258 14.7832 5.04492L5.04492 14.7832C4.97461 14.8535 4.89258 14.9121 4.79883 14.959C4.70508 14.9941 4.60547 15.0117 4.5 15.0117H0.755859C0.544922 15.0117 0.363281 14.9414 0.210938 14.8008C0.0703125 14.6484 0 14.4668 0 14.2559V10.5117C0 10.4062 0.0175781 10.3066 0.0527344 10.2129C0.0996094 10.1191 0.158203 10.0371 0.228516 9.9668L9.9668 0.228516C10.1191 0.0761719 10.2949 0 10.4941 0C10.7051 0 10.8867 0.0761719 11.0391 0.228516Z"
											fill="currentColor"
										/>
									</svg>
								</button>
								<button
									type="button"
									class="jepto-page-editor__action-btn"
									aria-label="Add new page"
									matTooltip="Add new page"
									(click)="onAddTab()"
								>
									<mat-icon class="material-symbols-outlined"
										>add</mat-icon
									>
								</button>
							</div>
						}
					</div>
				}
			</ng-template>
			@if (!viewOnly() && !tabsBarInToolbar()) {
				<ng-container [ngTemplateOutlet]="tabsBarTpl" />
			}

			<div
				class="jepto-page-editor__content"
				[class.jepto-page-editor__content--transparent]="
					contentBackground() === 'transparent'
				"
				role="region"
				[attr.aria-label]="
					'Content for ' + (activePage()?.label ?? 'page')
				"
			>
				@if (showPreviewModeTabs()) {
					<div
						class="jepto-page-editor__preview-tabs"
						data-role="preview-page-tabs"
					>
						<jepto-page-editor-tabs
							[tabs]="displayedPages()"
							[selectedIndex]="displayedSelectedIndex()"
							[viewOnly]="true"
							[initialDropdownOpen]="initialDropdownOpen()"
							[testId]="
								testId() ? testId() + '-preview-tabs' : null
							"
							[ariaLabel]="ariaLabel()"
							(tabChange)="onTabChange($event)"
						/>
					</div>
				}
				<ng-content />
			</div>
		</div>

		@if (!viewOnly()) {
			<jepto-page-editor-manage-pages
				[pages]="currentPages()"
				[open]="managePanelOpen()"
				[tabsEnabledInPreview]="tabsEnabledInPreview()"
				(pagesChange)="onManagePagesChange($event)"
				(pageDeleteRequest)="onPageDeleteRequest($event)"
				(closePanel)="closeManagePanel()"
				(tabsEnabledInPreviewChange)="
					onTabsEnabledInPreviewChange($event)
				"
			/>
		}
	</div>
</div>
